module.exports = __webpack_public_path__ + "static/media/Slide_2_Banner_HERTZ2.1d868fda.webp";